import CompLayout from "@/pcomponents/comp/layout/layout";
import VideoUseDetailListArea from "@/pages/comp/plan/video/acommon/history/use_detail/list";

function VideoUseDetailListPage() {
  return (
    <CompLayout>
      <VideoUseDetailListArea></VideoUseDetailListArea>
    </CompLayout >
  );
};
export default VideoUseDetailListPage;